import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { frequencyFromNote } from '../../lib/noteHelper';

class PitchVisualizer extends Component {
  static propTypes = {
    // TODO: usare PropTypes.shape() ??
    note: PropTypes.object,
    verbose: PropTypes.bool
  };

  render() {
    const { note, verbose } = this.props;
    const pitchValue = note ? note.frequency : '--';
    const octave = note ? note.octave : 0;
    const noteString = note ? note.traditionalName() : '';
    const duration = note ? note.duration : '';

    // TODO: calcolare detune solo se necessario (magari nel costruttore?)
    // cosi' si rifanno i conti un sacco di volte.
    const detune = verbose && note ? note.frequency - frequencyFromNote(note) : 0;
    return (
      <div id="detector" className="vague">
        <div className="note">
          <span id="note">{noteString}</span>
        </div>
        {verbose && (
          <div>
            <div className="pitch">
              <span id="pitch">{pitchValue}</span>Hz
            </div>
            <div id="detune">
              {detune && <span id="detune_amt">{detune}</span>}
              {detune < 0 && <span id="flat"> &#9837;</span>}
              {detune > 0 && <span id="sharp"> &#9839;</span>}
            </div>
            <div id="octave">Octave: {octave ? octave : '--'}</div>
            <div id="duration">Durata: {duration}</div>
          </div>
        )}
      </div>
    );
  }
}

export default PitchVisualizer;
